





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ConfigureReviewerEnum } from "../../types";
import { Getter } from "vuex-class";

@Component
export default class ConfigureReviewersType extends Vue {
  @Getter private currentTeamID!: string;
  @Prop() private selectedTypeOption?: ConfigureReviewerEnum;

  private freeformDesc = `Freeform review mechanism works on a first come first serve basis.  
  All submitted recordings will appear in the "Review Required" table. 
  Any reviewer/manager in the team can review the recording and submit feedback. 
  After giving feedback, once the submit button has been clicked the recording will move to the "Review Completed" table`;

  private customDesc = `Custom review mechanism allows you to assign a reviewer/manager to each user.
  Clicking on the "Distribute Randomly" button distributes learners randomly among the reviewers you have added.
  Reviewer-Manager assignments will only be stored upon clicking of the "Save" button.
  Each reviewer/manager will see the submissions of the users assigned to them`;

  private options: any = [
    {
      text: ConfigureReviewerEnum.Freeform.toString(),
      value: ConfigureReviewerEnum.Freeform
    },
    {
      text: ConfigureReviewerEnum.Custom.toString(),
      value: ConfigureReviewerEnum.Custom
    }
  ];

  private selectedTypeDescription!: string;

  @Watch("selectedTypeOption", { immediate: true })
  private changeTypeOption() {
    if (this.selectedTypeOption === ConfigureReviewerEnum.Freeform) {
      this.selectedTypeDescription = this.freeformDesc;
    } else if (this.selectedTypeOption === ConfigureReviewerEnum.Custom) {
      this.selectedTypeDescription = this.customDesc;
    } else {
      this.selectedTypeDescription = "";
    }
  }

  private onChange(type: any) {
    this.$emit("configureTypeSelect", type);
  }
}
